export const availableRoles = {
    "Doer": ['Doer'],
    "Knight": ['Doer', 'Knight'],
    "Merchant": ['Doer', 'Knight', 'Merchant'], 
    "Baron": ['Doer', 'Merchant', 'Knight', 'Baron'],
    "King": ['Doer', 'Merchant', 'Knight', 'Baron', 'King', 'Admin'],
    "Admin": ['Doer', 'Knight','Merchant', 'Baron', 'King', 'Admin']
}
